import { render } from "./VueLazyYoutubeVideo.vue?vue&type=template&id=765fe0af"
import script from "./VueLazyYoutubeVideo.vue?vue&type=script&lang=js"
export * from "./VueLazyYoutubeVideo.vue?vue&type=script&lang=js"

import "./VueLazyYoutubeVideo.vue?vue&type=style&index=0&id=765fe0af&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/VueLazyYoutubeVideo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "765fe0af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('765fe0af', __exports__)) {
    api.reload('765fe0af', __exports__)
  }
  
  module.hot.accept("./VueLazyYoutubeVideo.vue?vue&type=template&id=765fe0af", () => {
    api.rerender('765fe0af', render)
  })

}


export default __exports__